import { Box, Button, Container, Grid2, Typography } from '@mui/material';
import React from 'react';
import img from '../assets/worker.png'; // Substitua pelo caminho da sua imagem


const About = () => (
    <Box
      id="about"
      sx={{
        py: 6,
        px: { xs: 2, sm: 4, md: 8 },
        minHeight: '60vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Container maxWidth="lg">
        <Grid2
          container
          spacing={4}
          sx={{
            alignItems: 'center', // Alinha verticalmente
          }}
        >
          <Grid2 xs={12} md={6} maxWidth={"sm"}>
            <Typography
              variant="h6"
              sx={{
                color: '#1A7B30',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                marginBottom: 2,
              }}
            >
              Construção com Qualidade
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: 3 }}>
              Qualidade em construção no seu melhor
            </Typography>
            <Typography variant="body1" paragraph>
            Thiago Obras é uma empresa especializada em serviços de construção e reformas, localizada no Rio de Janeiro. Com uma equipe altamente qualificada e anos de experiência no setor, oferecemos soluções completas e personalizadas para atender às necessidades de nossos clientes.

            </Typography>
            <Typography variant="body1" paragraph>
            Na Thiago Obras, priorizamos a excelência, a pontualidade e a satisfação de nossos clientes. Nosso compromisso é transformar sua visão em realidade com segurança, qualidade e atenção aos detalhes.

            </Typography>
            <Button
              variant="text"
              href="#contact"
              sx={{
                fontWeight: 'bold',
                textTransform: 'none',
                color: '#1A7B30',
                ':hover': { textDecoration: 'underline' },
              }}
            >
              Entre em contato
            </Button>
          </Grid2>
          <Grid2 xs={12} md={6} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Box
              component="img"
              src={img}
              alt="Imagem de construção"
              sx={{
                width: '100%',
                maxWidth: '400px',
                maxHeight: '400px',
                borderRadius: '8px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                objectFit: 'cover',
              }}
            />
          </Grid2>
        </Grid2>
      </Container>
    </Box>
  );
  
  export default About;